export default __webpack_public_path__ + "static/media/sales-funnel.4eee7863.svg";